export default "__VITE_ASSET__LmoUc046__"